import React from 'react';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { BrowserRouter } from 'react-router-dom';

import Routes from './Routes';
import configureStore from './store/configureStore';
import './styles/index.less';

const store = configureStore((window as any).__AS_INITIAL_STATE__);

const App = () => (
    <AppContainer>
        <Provider store={ store }>
            <BrowserRouter>
                { renderRoutes(Routes) }
            </BrowserRouter>
        </Provider>
    </AppContainer>
);

export default App;
